import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "frequencies-container" }
const _hoisted_2 = {
  key: 0,
  class: "rd-w-full frequency-text"
}
const _hoisted_3 = { class: "rd-lowercase" }
const _hoisted_4 = {
  key: 1,
  class: "frequency-text"
}

import { Frequency, frequencyDisplayName } from '@/enums';
import { PropType } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'FrequencyWarningSnippet',
  props: {
    frequency: {
        type: Number as PropType<Frequency | null>,
        required: true
    }
},
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (__props.frequency !== null && __props.frequency !== _unref(Frequency).OneTime)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
          _cache[0] || (_cache[0] = _createTextVNode(" This will create a recurring schedule, charged ")),
          _createElementVNode("strong", _hoisted_3, _toDisplayString(_unref(frequencyDisplayName)(__props.frequency)), 1),
          _cache[1] || (_cache[1] = _createTextVNode(". "))
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_4, _cache[2] || (_cache[2] = [
          _createTextVNode(" This will be processed as a "),
          _createElementVNode("strong", { class: "rd-lowercase" }, "one time", -1),
          _createTextVNode(" gift. ")
        ])))
  ]))
}
}

})